import { fetchCarHireOfferImportantInfo } from 'actions/CarHireActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

const EmptyList: App.CarHireOfferImportantInformationList = {
  data: [],
  error: undefined,
  fetching: true,
}

export interface IncludedCoverages {
  title: string;
  excess: number;
  currency: string;
}

function useCarHireOfferImportantInformation(params: App.CarHireOfferImportantInformationParams, offerReferenceId: string) {
  const dispatch = useAppDispatch()

  const list = useAppSelector(state => state.carHire.offerImportantInformationLists[offerReferenceId]) ?? EmptyList

  const includedCoverages: Array<IncludedCoverages> = useMemo(() => {
    const offerImportantInformation = list.data

    if (offerImportantInformation.length > 0) {
      const coverages = (offerImportantInformation || []).find(item => item.category === 'Coverage')

      const values = (coverages?.paragraphs || []).map((paragraph) => {
        const str = paragraph.split('Excess')
        const excessStrValue = str.length > 1 ? str[1].replace(',', '') : ''
        const currStr = excessStrValue.trim().split(' ')
        const currency = currStr.length > 1 ? currStr[1].substring(0, 3) : ''
        const excess = excessStrValue ? parseInt(excessStrValue) : 0
        const title = str[0].split(':')[0]

        const includedCoverage = { title, excess, currency }

        return includedCoverage
      })

      return values.filter(item => !isNaN(item.excess))
    }
    return []
  }, [list])

  useEffect(() => {
    if (offerReferenceId) {
      dispatch(fetchCarHireOfferImportantInfo(params))
    }
  }, [dispatch, offerReferenceId, params])

  return {
    offerImportantInformation: list,
    includedCoverages,
  }
}

export default useCarHireOfferImportantInformation
